/** Named appointment slots from product requirements (display order). */
export const APPOINTMENT_SLOTS = {
  ALLDAY: 'All Day',
  MORNING: 'Morning',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening',
};

/**
 * Default schedule grid / persistence keys (requirements JSON includes EVENING).
 * Row order: All Day, Morning, Afternoon, Evening.
 */
export const SCHEDULE_SLOT_KEYS = ['ALLDAY', 'MORNING', 'AFTERNOON', 'EVENING'];

export const SCHEDULE_SLOT_LABELS = {
  ALLDAY: 'All Day',
  MORNING: 'Morning',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening',
};

/** Slot keys for requirements.md custom rule JSON (`ALL_DAY` vs grid `ALLDAY`). */
export const CUSTOM_RULE_SLOT_KEYS = [
  'ALL_DAY',
  'MORNING',
  'AFTERNOON',
  'EVENING',
];

export const CUSTOM_RULE_SLOT_LABELS = {
  ALL_DAY: 'All Day',
  MORNING: 'Morning',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening',
};

/** Weekday abbreviations used in custom schedule rule JSON. */
export const RULE_JSON_WEEKDAY_KEYS = [
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
  'SUN',
];

export const RULE_JSON_WEEKDAY_LABELS = {
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun',
};

export const WEEKDAY_KEYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const WEEKDAY_LABELS = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
};

export const WEEKDAY_SHORT_LABELS = {
  MONDAY: 'Mon',
  TUESDAY: 'Tue',
  WEDNESDAY: 'Wed',
  THURSDAY: 'Thu',
  FRIDAY: 'Fri',
  SATURDAY: 'Sat',
  SUNDAY: 'Sun',
};

export const COPY_NONE = '__none__';
/** Copy source weekday to every other day in the grid (Copy To menu). */
export const COPY_ALL_OTHER_DAYS = '__all_other_days__';
export const CUTOFF_DAY_OFFSETS = [0, 1, 2, 3, 4, 5, 6];

/** Persisted per-weekday on `schedule[weekday]` alongside slot booleans. */
export const CUTOFF_KEY = 'cutoff';

/** Default cutoff time stored as top-of-hour only (`HH:00`). */
export const DEFAULT_CUTOFF_TIME = '12:00';

/** Selectable cutoff hours (24h). */
export const CUTOFF_HOUR_RANGE = Array.from({ length: 24 }, (_, i) => i);

export const TIME_LIKE_RE = /^([01]?\d|2[0-3])(?::([0-5]\d))?$/;

export const DEFAULT_SCHEDULE_CURRENT_ID = 'current';

export const CURRENT_VIEW = {
  EDIT_SCHEDULE: 'EDIT_SCHEDULE',
  VIEW_SCHEDULE: 'VIEW_SCHEDULE',
  DEFAULT: 'DEFAULT',
};

export const NON_RECURRING_DURATION = [
  {
    label: 'Single',
    value: 'SINGLE',
  },
  {
    label: 'Multi Day',
    value: 'RANGE',
  },
];

export const RECURRENCE_PATTERN = [
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Yearly', value: 'YEARLY' },
];

export const WEEKDAYS_LONG = [
  { label: 'Sunday', value: 'SUNDAY' },
  { label: 'Monday', value: 'MONDAY' },
  { label: 'Tuesday', value: 'TUESDAY' },
  { label: 'Wednesday', value: 'WEDNESDAY' },
  { label: 'Thursday', value: 'THURSDAY' },
  { label: 'Friday', value: 'FRIDAY' },
  { label: 'Saturday', value: 'SATURDAY' },
];

export const END_DATE_OPTIONS = [
  { label: 'No end date', value: 'NO_END_DATE' },
  { label: 'End by', value: 'END_BY' },
];

export const WEEK_OF_MONTH_OPTIONS = [
  { label: 'First', value: 'FIRST' },
  { label: 'Second', value: 'SECOND' },
  { label: 'Third', value: 'THIRD' },
  { label: 'Fourth', value: 'FOURTH' },
  { label: 'Last', value: 'LAST' },
];

export const FIRST_LAST_WEEK_OF_MONTH_OPTIONS = [
  { label: 'First', value: 'FIRST' },
  { label: 'Last', value: 'LAST' },
];

export const MONTHS = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const MAX_WIDTH_HORZ_LAYOUT = '170px';
